function startCountdown2(hours, minutes) {
    const duration = (hours * 60 * 60 * 1000) + (minutes * 60 * 1000);

    function resetEndTime() {
        const newEndTime = Date.now() + duration;
        // Đổi key localStorage để không lưu trùng thời gian với thanh cũ
        localStorage.setItem('countdownEndTime2', newEndTime.toString());
        return newEndTime;
    }

    let endTime = localStorage.getItem('countdownEndTime2');
    if (!endTime) {
        endTime = resetEndTime();
    } else {
        endTime = parseInt(endTime, 10);
        if (isNaN(endTime)) {
            endTime = resetEndTime();
        }
    }

    function updateCountdown() {
        const now = new Date().getTime();
        const distance = endTime - now;

        if (distance < 0) {
            endTime = resetEndTime();
            updateCountdown(); 
            return;
        }

        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Update ID tương ứng với HTML mới
        const hoursEl = document.getElementById('ab2-hours');
        const minutesEl = document.getElementById('ab2-minutes');
        const secondsEl = document.getElementById('ab2-seconds');

        if(hoursEl) hoursEl.textContent = hours.toString().padStart(2, '0');
        if(minutesEl) minutesEl.textContent = minutes.toString().padStart(2, '0');
        if(secondsEl) secondsEl.textContent = seconds.toString().padStart(2, '0');
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
}

document.addEventListener('DOMContentLoaded', () => {
    // Tìm meta name mới
    const hoursMeta = document.querySelector('meta[name="countdown-hours-2"]');
    const minutesMeta = document.querySelector('meta[name="countdown-minutes-2"]');
    
    if (hoursMeta && minutesMeta) {
        const hours = parseInt(hoursMeta.getAttribute('content'), 10);
        const minutes = parseInt(minutesMeta.getAttribute('content'), 10);
        startCountdown2(hours, minutes);
    }
});